 <!--促销组件商品-->
<template>
  <div class="wrapper-right">
    <div
      class="h-a-item"
      v-for="(item, index) in items"
      :key="index"
      @mouseenter="selected = index"
      @mouseleave="mouseleave($event)"
    >
      <!-- 商品图片 -->
      <div class="img-div">
        <a href="javascrip:void(0)" @click="jumpToDetail(item)">
          <img :src="item.productImgPath" />
        </a>
      </div>
      <!-- 商品名称 -->
      <div class="text-div">
        <p>
          <!-- 签约商品标签 -->
          <span
            class="cont"
            v-for="(cont, index) in item.contract"
            :key="index"
            >{{ cont }}</span
          >
          <a
            href="javascrip:void(0)"
            @click="jumpToDetail(item)"
            style="text-decoration: none; color: black"
          >
            <span :title="item.productName" class="spantitle">{{
              item.productName
            }}</span>
          </a>
        </p>
      </div>
      <!-- 商品供应商 -->
      <div class="supplier-div">
        <p>{{ item.supplier }}</p>
      </div>
      <!-- 商品价格 -->
      <div class="price-tags">
        <p class="price">{{constant.currencySymbol}}{{ item.shopPrice }}</p>
        <!-- 降价标签 -->
        <div class="tags">
          <span class="tag" v-for="(tag, tIndex) in item.tags" :key="tIndex">{{
            tag
          }}</span>
        </div>
        <!-- 加入购物车 -->
        <a
          class="addcart"

          :key="index"
          @click="addToCart(item, index)"
        >
          <img src="img/ncart.png" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  props: ["items"],
  data() {
    return {
      isMouseEnter: false,
      selected: -1,
      addShow: false,
      constant: this.$store.state.malMainPageConfig.constant,
    };
  },
  methods: {
    // 添加到购物车
    addToCart(item, index) {
      this.$api.mainpageApi
        .addToCart(item.productId, item.source)
        .then((response) => {
          if (response.data.success) {
            this.$store.commit({
              type: "updateCartNum",
              currentNum: response.data.data,
            });
            this.$message({
              showClose: true,
              message:
                item.productName +
                this.$store.state.malMainPageConfig.constant.addToCartSuccess,
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message:
                item.productName +
                this.$store.state.malMainPageConfig.constant.addToCartFail,
              type: "error",
            });
          }
        })
        .catch((error) => {
          this.$message({
            showClose: true,
            message:
              item.productName +
              this.$store.state.malMainPageConfig.constant.addToCartFail,
            type: "error",
          });
        });
    },
    jumpToDetail(product) {
      // 进去新版商品详情
      let param = "";
      if (product.source == "1") {
        param = "&productSelfId=" + product.productId;
      } else {
        param =
          "&productJdSku=" +
          product.productnumber +
          "&productsource=" +
          product.source;
      }
      let url = axios.defaults.baseURL + "/index.html?formId=mal_newproductdetail" + param;
      window.open(url, "_blank");
    },
    mouseleave(event) {
      if (event.relatedTarget != null) {
        this.selected = -1;
      }
    },
  },
};
</script>

<style scoped lang="scss">
a{
  cursor:pointer
}
.wrapper-right {
  width: 1000px;
  height: 349px;
  color: #333;
  display: flex;
  flex-flow: wrap;
  justify-content: flex-start;
  align-content: space-between;
}
.wrapper-right .active {
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  margin-top: -1px;
  transition: all 0.2s linear;
}
.h-a-item {
  position: relative;
  z-index: 1;
  overflow: hidden;
  height: 349px;
  width: 198px;
  margin-left: 2px;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
}
.h-a-item .img-div a img {
  width: 172px;
  height: 172px;
  margin-top: 12px;
}
.h-a-item .price {
  // 苹方-简 中黑体
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 20px;
  width: 100px;
  color: #ed542b;
  letter-spacing: 0;
  text-align: left;
  line-height: 20px;
  margin: 0px;
}

.h-a-item .tags {
  display: flex;
  justify-content: flex-end;
  font-size: 12px;
  font-weight: 400;
  height: 20px;
  margin: 0px;
  font-family: PingFangSC-Regular;
  color: #ffffff;
  letter-spacing: 0;
  overflow: hidden;
}
.h-a-item .tags .tag {
  border: 1px solid #fd6c6a;
  border-radius: 9px;
  padding: 0 3px 0 4px;
  margin: 0 0 0 5px;
  height: 16px;
  // 苹方-简 中黑体
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 12px;
  color: #fd6c6a;
  letter-spacing: 0;
  text-align: center;
}
.img-div {
  width: 172px;
  height: 172px;
}
.text-div {
  width: 172px;
  font-size: 14px;
  height: 36px;
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  color: #333333;
  letter-spacing: 1px; //设置字体行间距
  // 苹方-简 常规体
  font-family: PingFangSC-Regular, sans-serif;
}

.text-div .cont {
  background: #2386ee;
  border: 1px solid #2386ee;
  border-radius: 9px;
  padding: 0 3px 0 3px;
  margin: 0 0 0 5px;
  height: 16px;
  // 苹方-简 中黑体
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 12px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  margin-left: 1px;
}

.text-div .spantitle {
  margin-left: 4px;
}

.text-div p {
  width: 172px;
  text-align: left;
  height: 36px;
  line-height: 20px;
  text-overflow: ellipsis; //设置隐藏部分为省略号
  overflow: hidden; //设置隐藏
  display: -webkit-box;
  -webkit-line-clamp: 2; //设置显示行数，此处为2行，可设置其他数字
  -webkit-box-orient: vertical;
}
.text-div a :hover {
  color: #2386ee;
}
.supplier-div p {
  width: 172px;
  text-align: left;
  overflow: hidden;
  // 苹方-简 常规体
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 12px;
  color: #999999;
  letter-spacing: 0;
  height: 18px;
  line-height: 18px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.price-tags {
  width: 172px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0px 10px 0px;
}
.add_img {
  width: 100px;
  height: 100px;
  z-index: 999;
}
</style>
